import { lazyImport } from '../../../Utils'

export const Select = lazyImport(() => import('@mui/material/Select'))
